import { Breadcrumbs, Link, Typography } from "@mui/material"

export const BreadCrumbsCustom = (props) => {
  const {RouterLink,linkConfig, typographyText, className} = props
  return (
    <Breadcrumbs className={className ? className : "site-breadcrumbs"}>
      {linkConfig.map((config, index) => (
        <Link component={RouterLink} to={config.to} key={index}>
          {config.textLink}
        </Link>
      ))}
      <Typography color="textPrimary">
        {typographyText}
      </Typography>
    </Breadcrumbs>
  )
}


